'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".CpCustomComponent-module_iframe__FEdCg{background-color:transparent;border:0;display:none;margin:0;padding:0;width:100%}";
var styles = {"iframe":"CpCustomComponent-module_iframe__FEdCg"};
styleInject["default"](css_248z, '6240a377-7227-4a51-9e00-6bdea2895b39');

exports["default"] = styles;
